import React, { FC, useEffect, useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import { Receipt } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

import api from '../../api/api';
import FormContainer from './form-container';

interface DownloadProps {
  id: string;
}

const Download: FC<DownloadProps> = (props) => {
  const { id } = props;

  const [url, setUrl] = useState<string | undefined>();

  useEffect(
    () => {
      api.file.get(id).then((response) => {
        if (response?.status === 200) {
          const linkElement = document.createElement('a');
          setUrl(
            `data:${response.headers['content-type']};base64,` + response.data
          );
          linkElement.href =
            `data:${response.headers['content-type']};base64,` + response.data;
          linkElement.download = '';
          document.body.appendChild(linkElement);
          linkElement.click(); // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
          document.body.removeChild(linkElement);
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <FormContainer>
      <Box maxWidth="400px" textAlign="center" marginX="auto">
        <Alert severity="info">
          <Box display="flex" justifyContent="center" flexDirection="column">
            <Box display="flex" justifyContent="center" flexDirection="column">
              <Typography>
                Скачивание файла начнется автоматически. Если этого не
                произошло, то нажмите на ссылку ниже.
              </Typography>
            </Box>
            <Box display="flex" justifyContent="center" flexDirection="column">
              <a href={url} download="">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  my={2}
                >
                  <Receipt color="primary" fontSize="large" />
                  <Typography color="primary">Скачать</Typography>
                </Box>
              </a>
            </Box>
          </Box>
        </Alert>
      </Box>
    </FormContainer>
  );
};

export default Download;
